export const defaultSeoActivities = [
  { name: 'Relatório' },
  { name: 'Validação' },
  { name: 'Mapeamento' },
  { name: 'Estudo' },
  { name: 'Análise' },
  { name: 'Organização' },
  { name: 'Rotina' },
  { name: 'Bug' },
  { name: 'Planejamento' },
];
